import React, { useState } from 'react';
import classNames from 'classnames';
import $ from 'sitewide-jquery';

import { WorkId } from 'js/liswp/types';
import FeedbackOption from './feedback_option';

interface NotInterestedModalProps {
  reportWork: (choices: string[], workId: WorkId, category: string) => void;
  workId: WorkId;
}

const NotInterestedModal: React.FC<NotInterestedModalProps> = ({
  reportWork,
  workId,
}) => {
  const [choices, setChoices] = useState<string[]>([]);

  const recordChoice = (choice: string) => {
    if (choices.includes(choice)) {
      setChoices(choices.filter((c) => c !== choice));
    } else {
      setChoices([...choices, choice]);
    }
  };

  const onSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (choices.length === 0) {
      return;
    }

    let category = 'personal';
    if (choices.includes('spam')) {
      category = 'general';
    }

    reportWork(choices, workId, category);
    $('.modal').modal('hide');
  };

  const onCancel = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    $('.modal').modal('hide');
  };

  const submitButtonClasses = classNames('work-card-modal--submit-button', {
    valid: choices.length > 0,
  });

  return (
    <div className="work-card-modal--container">
      <div className="work-card-modal--header">
        We'll show you fewer papers like that one. Was there something in
        particular you didn't like?
      </div>
      <div className="work-card-modal--sub-header">
        We use your feedback to show you, and other academics, only high quality
        papers.
      </div>
      <div className="work-card-modal--body">
        <FeedbackOption
          onClick={() => recordChoice('not_interested')}
          iconName="fa-ban"
          color="blue"
          text="I'm not interested in this topic"
          selected={choices.includes('not_interested')}
        />
        <FeedbackOption
          onClick={() => recordChoice('dislike_author')}
          iconName="fa-user-slash"
          color="yellow"
          text="I don't like this author"
          selected={choices.includes('dislike_author')}
        />
        <FeedbackOption
          onClick={() => recordChoice('already_read')}
          iconName="fa-eye"
          color="green"
          text="I've already read this paper"
          selected={choices.includes('already_read')}
        />
        <FeedbackOption
          onClick={() => recordChoice('spam')}
          iconName="fa-flag"
          color="red"
          text="It's inappropriate or spam"
          selected={choices.includes('spam')}
        />
        <FeedbackOption
          onClick={() => recordChoice('other')}
          iconName="fa-question"
          color="gray"
          text="Something else"
          selected={choices.includes('other')}
        />
      </div>
      <div className="work-card-modal--actions">
        <div className="work-card-modal--cancel-button" onClick={onCancel}>
          Cancel
        </div>
        <button className={submitButtonClasses} onClick={onSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default NotInterestedModal;
